var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 1496,
    height: 1496,
    viewBox: "0 0 1496 1496",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7776.02,3076.96 H 3443.98 c -269.04,0 -489.17,220.13 -489.17,489.17 v 401.26 c 0,47.71 39.04,86.75 86.75,86.75 h 5136.88 c 47.71,0 86.75,-39.04 86.75,-86.75 v -401.26 c 0,-269.04 -220.13,-489.17 -489.17,-489.17",
    style: {
      fill: "#e4a330",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8265.19,3566.13 v 401.26 c 0,47.71 -39.04,86.75 -86.75,86.75 H 7905.91 C 7279.21,3563.81 6168.98,3272.53 5190.28,3076.96 h 2585.74 c 269.04,0 489.17,220.13 489.17,489.17",
    style: {
      fill: "#e1972f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8023.72,5175.17 H 3196.28 c -58.03,0 -105.52,-47.48 -105.52,-105.52 v -172.67 c 0,-58.04 47.49,-105.52 105.52,-105.52 h 4827.44 c 58.03,0 105.52,47.48 105.52,105.52 v 172.67 c 0,58.04 -47.49,105.52 -105.52,105.52",
    style: {
      fill: "#c72b2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7341.83,4054.14 h 466.25 c 170.82,0 310.58,139.77 310.58,310.59 v 116.14 c 0,110.01 -58.13,206.88 -145.03,262.1 -96.75,-319.4 -408.81,-555.53 -631.8,-688.83",
    style: {
      fill: "#7c4226",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8030.71,5162.66 H 3238.85 c -92.6,67.13 -148.09,122.62 -148.09,190.44 v 505.25 c 0,67.82 55.49,123.31 123.31,123.31 h 4791.86 c 67.82,0 123.31,-55.49 123.31,-123.31 V 5353.1 c 0,-67.82 -55.49,-123.31 -98.53,-190.44",
    style: {
      fill: "#a35f30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8339.2,5705.73 c -0.66,1.31 -215.83,428.42 -215.83,428.42 H 5753.58 5466.42 3096.63 c 0,0 -215.17,-427.11 -215.83,-428.42 -110.61,-219.57 250.47,-271.17 366.41,-199.7 47.34,29.19 83.03,75.68 128.99,106.44 149.17,99.82 315.39,41.47 442.34,-71.97 0,0 416.78,-446.15 803.79,-35.11 129.23,137.25 286.54,210.98 461.09,117.83 158,-84.33 277.81,-249.72 445.74,-311.97 116.1,-43.04 243.91,-5.65 339.77,74.78 64.54,54.16 98.58,137.95 169.19,183.48 182.78,117.89 408,96.83 559.56,-64.13 387.01,-411.02 803.78,35.12 803.78,35.12 126.95,113.44 293.17,171.79 442.34,71.97 45.96,-30.76 81.65,-77.25 128.99,-106.44 115.94,-71.47 477.02,-19.87 366.41,199.7",
    style: {
      fill: "#4d713d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2998.05,6059.63 v 0 c 0,981.12 1127.15,2083.41 2561.33,2083.41 v 0 c 1434.18,0 2653.88,-1102.29 2653.88,-2083.41 v 0 H 2998.05",
    style: {
      fill: "#e4a330",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7146.1,7637.83 C 6834.79,6813.63 6118.92,6331.88 5506.04,6059.63 h 2704.07 c -11.78,631.16 -530.85,1287.92 -1064.01,1578.2",
    style: {
      fill: "#e1972f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4630.91,7422.29 c -52.14,-62.04 -117.19,-93.19 -145.3,-69.57 -28.11,23.62 -8.64,93.07 43.5,155.11 52.14,62.05 117.19,93.2 145.3,69.58 28.11,-23.63 8.64,-93.07 -43.5,-155.12",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6510.93,7407.49 c -70.19,-40.52 -141.97,-47.6 -160.32,-15.8 -18.36,31.8 23.65,90.43 93.83,130.95 70.19,40.52 141.97,47.59 160.33,15.79 18.36,-31.79 -23.66,-90.42 -93.84,-130.94",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5587.8,7421.97 c -16.88,-79.27 -59.67,-137.32 -95.59,-129.68 -35.91,7.65 -51.34,78.11 -34.46,157.38 16.88,79.26 59.68,137.32 95.59,129.67 35.91,-7.65 51.34,-78.1 34.46,-157.37",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5150.77,7719.15 c 53.53,-60.86 74.57,-129.85 47,-154.1 -27.56,-24.25 -93.31,5.43 -146.83,66.28 -53.53,60.85 -74.57,129.84 -47,154.09 27.57,24.25 93.31,-5.42 146.83,-66.27",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6064.56,7700.67 c 75.31,-29.92 125.39,-81.83 111.84,-115.95 -13.56,-34.13 -85.6,-37.54 -160.92,-7.63 -75.32,29.91 -125.39,81.83 -111.84,115.95 13.55,34.13 85.6,37.54 160.92,7.63",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4013.34,5140.79 1320.02,-375.27 h 817.68 c 0,0 -794.43,361.02 -2137.7,375.27",
    style: {
      fill: "#ad262b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7992.57,4054.14 H 3227.43 c -95.83,0 -174.24,78.41 -174.24,174.24 v 388.84 c 0,95.83 78.41,174.24 174.24,174.24 h 4765.14 c 95.83,0 174.24,-78.41 174.24,-174.24 v -388.84 c 0,-95.83 -78.41,-174.24 -174.24,-174.24",
    style: {
      fill: "#844d29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5236.67,4791.46 c 0,0 1262.61,-367.49 1642.11,-651.43 l 687.03,641.02 -2329.14,10.41",
    style: {
      fill: "#7c4226",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6858.26,4345.6 785.58,815.32 -3823.14,1.74 c 0,0 1740.32,-120.34 3037.56,-817.06",
    style: {
      fill: "#eec131",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3146.17,6211.17 c 0,0 315.92,1394.26 1880.33,1704.05 0,0 -1174.03,-657.25 -1880.33,-1704.05",
    style: {
      fill: "#ebba63",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.506c3c1ab46e73037b781c3eba40d223.svg";
export { ForwardRef as ReactComponent };